/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M350.385 329.116c-2.107 40.81-15.88 73.484-37.98 97.91-12.545 13.861-27.896 24.977-45.086 33.44-26.624 13.115-57.98 19.825-91.887 19.825C77.586 480.291 0 425.138 0 318.322V191.946C0 85.392 76.93 30.242 174.511 30h.702c96.839 0 173.683 53.969 175.391 158.481v1.186c0 2.982-1.098 5.788-3.247 7.936-.743.791-1.622 1.403-2.583 1.908-1.888 1.073-4.038 1.754-6.317 1.754h-88.86c-2.193 0-4.21-.725-6.05-1.754-3.072-1.666-5.307-4.387-5.969-7.852-.172-1.073-.437-2.105-.653-3.202-.88-4.25-1.887-8.46-3.114-12.476-8.728-23.902-31.578-40.962-58.509-40.962-34.384 0-62.277 27.85-62.277 62.3v116.554c0 34.45 27.893 62.299 62.277 62.299 29.998 0 55.001-21.186 60.962-49.361.088-.223.878-4.104 1.145-5.834 1.05-5.526 6.138-9.583 12.1-9.583h88.949c3.42 0 6.575 1.358 8.945 3.662 1.84 1.906 2.984 4.364 3.202 6.928.04.53-.18 6.298-.22 7.132zm99.951 152.977c-35.57 0-62.452-29.252-62.452-64.824 0-33.22 26.882-60.854 61.664-60.854 35.57 0 62.452 27.63 62.452 60.854 0 34.778-23.728 64.824-61.664 64.824z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconCAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconCAlt.defaultProps = {
  theme,
};
IconCAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconCAlt.displayName = 'IconCAlt';
export { IconCAlt };
